import { Icon } from "../Icon"
import { mergeRefs } from "../utils/mergeRefs"
import { forwardRef, useRef, useState } from "react"
import { TextInput, TextInputProps } from "../TextInput"

export const PasswordInput = forwardRef<HTMLInputElement, TextInputProps>((props, ref) => {
  const [showPassword, setShowPassword] = useState(false)

  const inputRef = useRef<HTMLInputElement>()

  const refs = mergeRefs(ref, inputRef)

  return (
    <TextInput
      {...props}
      type={showPassword ? "text" : "password"}
      data-testid="password-input"
      ref={refs}
      endAdornment={
        <button
          className="flex items-center justify-center"
          type="button"
          onClick={() => {
            setShowPassword(prev => !prev)
            inputRef.current?.focus()
          }}
          data-testid="toggle-password-visibility"
        >
          <Icon name={showPassword ? "Eye" : "EyeSlash"} size="sm" />
        </button>
      }
    />
  )
})
